<!--suppress ALL -->
<template>
  <th :class="sorting ? 'has-pointer' : ''"
      :style="width ? `width:${width}px` : false">
    <div class="inner-th" :class="position ? `has-text-${position}` : ''">
      <a @click="onSorting">
        <span><slot></slot></span>
        <span v-if="currentSorting === thIndex" :class="`icon-arrow ${isSortAscending ? '' : 'is-up'}`"></span>
      </a>
    </div>
  </th>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'annotation';

  @Component
  export default class GTableColumnHead extends Vue {

    @Prop({default: false, type: Boolean})
    public sorting: boolean;

    @Prop({type: String})
    public position: string;

    @Prop({type: String})
    public thKey: string;

    @Prop([String, Number])
    public width!: string | number;

    @Prop([String, Number])
    public thIndex!: string | number;

    public get currentSorting() {
      if (this.$parent.isTableComponent) {
        return this.$parent.currentSorting;
      }

      return null;
    }

    public get isSortAscending() {
      if (this.$parent.isTableComponent) {
        return this.$parent.isSortAscending || false;
      }

      return false;
    }

    public onSorting() {
      if (this.$parent.isTableComponent && this.sorting && this.thKey) {
        this.$parent.onSortBy(this.thIndex, this.thKey);
      }
    }
  }
</script>
